import Api from './resource'
import token from '../utils/token'

export const AuthResource = () => Api.resource('/users')
export const CommonResource = () => Api.resource('/commons' + token.getToken('api'))
export const UserResource = () => Api.resource('/users' + token.getToken('api'))
export const FileResource = () => Api.resource('/files' + token.getToken('api'))
export const SearchResource = () =>  Api.resource('/search' + token.getToken('api'))
export const ViewResource = version => Api.resource(`${version ? '/' + version : ''}/views` + token.getToken('api'))
export const FollowResource = () => Api.resource('/follows' + token.getToken('api'))
export const HouseResource = () => Api.resource('/house' + token.getToken('api'))
export const SaleResource = () => Api.resource('/sale' + token.getToken('api'))
export const VisitorResource = () => Api.resource('/visitors' + token.getToken('api'))
export const PaymentResource = () => Api.resource('/payment' + token.getToken('api'))
export const MessageResource = () => Api.resource('/appwebmessage' + token.getToken('api'))
export const BonusResource = () => Api.resource('/bonuses' + token.getToken('api'))
export const TopicResource = () => Api.resource('/topic' + token.getToken('api'))
export const DemandResource = () => Api.resource('/demand' + token.getToken('api'))
export const RequirementResource = () => Api.resource('/appwebdemand' + token.getToken('api'))